<template>
  <div
    class="settings-row settings-row-xs"
    data-test="graphics-gapSettings"
  >
    <label
      class="sidebar-form-label"
      for="gap"
    >Item Gap</label>
    <div class="settings-col-12 settings-col-xs">
      <div class="input-group">
        <validation-field as="input"
          v-model.number="_gap"
          rules="required|numeric|min:0"
          type="number"
          step="1"
          min="0"
          name="gap"
          :class="{ 'is-invalid': validationErrors['gap'] }"
          :data-entity="`graphics-${action}`"
          :data-test="`graphics-${action}`"
        />
        <span class="input-group-addon">px</span>
      </div>
      <label class="sidebar-input-sub-label">{{ helpText }}</label>
    </div>
    <p
      v-if="validationErrors['gap']"
      class="text-danger"
    >
      {{ validationErrors['gap'] }}
    </p>
  </div>
</template>

<script>

export default {
  name: 'GapSettingsComponent',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      required: true,
      type: Number,
      default: 16,
    },
    action: {
      type: String,
      default: 'updateGap',
    },
    helpText: {
      type: String,
      default: 'Space between Ticker Items',
    },
  },

  computed: {
    _gap: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      },
    },
  },
};
</script>
